import { ctx } from '../canvas.js';
import { state } from '../state.js';
import { splashShots } from '../splash.js';

/** Frames of fuse left when the grenade starts glowing. A warning, not decoration. */
const FUSE_WARN_FRAMES = 36;

/**
 * Everything in flight: the match's projectile, and the lobs the opening scene is
 * throwing at nobody.
 *
 * The second is drawn here rather than in a renderer of its own so that the two
 * cannot end up being two different bananas.
 */
export function drawProjectile() {
  splashShots().forEach(drawInFlight);

  const p = state.projectile;
  if (p) drawInFlight(p);
}

/** Which weapon it is decides what it looks like. */
function drawInFlight(p) {
  ctx.save();
  ctx.translate(p.x, p.y);
  ctx.rotate(p.rot || 0);

  if (p.kind === 'grenade') drawGrenade(p);
  else if (p.kind === 'ball') drawBall(p);
  else if (p.kind === 'boomerang') drawBoomerang();
  else drawBanana();

  ctx.restore();
}

/**
 * El bumerán: dos brazos en ángulo, en madera clara, girando.
 *
 * El giro es la mitad de lo que lo hace legible —quieto es una ceja— y lo pone el `rot` que ya
 * traía la física, así que aquí sólo se dibuja la forma. Una L con el codo redondeado y una punta
 * más clara en cada brazo, que a 20 px de ancho es todo el detalle que cabe.
 */
function drawBoomerang() {
  ctx.fillStyle = '#d8a24c';
  ctx.beginPath();
  ctx.moveTo(-9, -7);
  ctx.lineTo(-5, -9);
  ctx.lineTo(7, 4);
  ctx.lineTo(9, 8);
  ctx.lineTo(4, 9);
  ctx.lineTo(-9, -3);
  ctx.closePath();
  ctx.fill();

  ctx.fillStyle = '#f0cd8a';
  ctx.fillRect(-8, -7, 3, 3);
  ctx.fillRect(5, 5, 3, 3);
}

/**
 * The four balls. At this size the colour is doing all the work, so each one gets a
 * colour and one line of pattern rather than an attempt at a real ball.
 */
function drawBall(p) {
  const r = p.r || 6;
  const art = {
    basket: ['#d8722c', '#5f2d10'],
    football: ['#f2f4f6', '#20242c'],
    rugby: ['#8a5a2b', '#e8dcc0'],
    tennis: ['#d8e04a', '#f6f8f0'],
  }[p.ball] || ['#d8722c', '#5f2d10'];

  ctx.fillStyle = art[0];
  ctx.beginPath();
  ctx.arc(0, 0, r, 0, Math.PI * 2);
  ctx.fill();

  ctx.fillStyle = art[1];

  if (p.ball === 'tennis') ctx.fillRect(-r, -1, r * 2, 2);
  else if (p.ball === 'football') ctx.fillRect(-1.5, -1.5, 3, 3);
  else if (p.ball === 'rugby') ctx.fillRect(-r + 1, -1.5, r * 2 - 2, 3);
  else {
    ctx.fillRect(-r, -1, r * 2, 2);
    ctx.fillRect(-1, -r, 2, r * 2);
  }
}

function drawBanana() {
  ctx.fillStyle = '#ffe07a';
  ctx.beginPath();
  ctx.ellipse(0, 0, 7, 3.5, 0, 0, Math.PI * 2);
  ctx.fill();

  // stem
  ctx.fillStyle = '#c8912f';
  ctx.beginPath();
  ctx.ellipse(-6, 0, 2, 1.6, 0, 0, Math.PI * 2);
  ctx.fill();
}

/**
 * A fragmentation grenade: olive body, dark cap, and a fuse that only starts
 * blinking once there is something to warn about. The glow is the only cue that
 * a grenade is about to go off where it sits rather than where it lands, so it
 * has to be readable at a glance.
 */
function drawGrenade(p) {
  ctx.fillStyle = '#4a5a34';
  ctx.beginPath();
  ctx.ellipse(0, 0, 6, 7, 0, 0, Math.PI * 2);
  ctx.fill();

  // The frag pattern, suggested rather than drawn: two bands read as one at this
  // size and a full grid just turns the body to mud.
  ctx.fillStyle = '#3a4728';
  ctx.fillRect(-5, -2, 10, 1);
  ctx.fillRect(-5, 2, 10, 1);

  // Cap, and the lever folded down the side.
  ctx.fillStyle = '#2f3a22';
  ctx.fillRect(-2, -9, 4, 3);
  ctx.fillRect(2, -8, 5, 2);

  if (p.fuse < FUSE_WARN_FRAMES) {
    const on = Math.floor(state.clock / 90) % 2 === 0;
    ctx.fillStyle = on ? '#ffd76a' : '#a8542a';
    ctx.fillRect(-1, -11, 2, 2);
  }
}

